import { useEffect } from "react";

export default function NotFound(){
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);
    return(
        <div className="wrapper" style={{flexDirection:"row", padding:"1rem"}}>
            <header style={{
                width:"50%"
            }}>
                <h1 style={{
                    fontSize:"14rem",
                    fontFamily:"var(--f1)",
                    display:"flex",
                    lineHeight:"10rem"
                }}>4
                    <span style={{
                        display:"inline-block",
                        width:"9rem"
                    }}>
                        <img 
                            style={{width:"100%", objectFit:"contain"}}
                            src="../images/bangle.png" alt="bangle"/>
                    </span>
                    4
                </h1>
                <h2 style={{
                        fontSize:"3rem",
                        fontFamily:"var(--f1)",
                        display:"flex",
                        lineHeight:"4rem"
                    }}>Page Not Found</h2>
                <p style={{
                    fontSize:"1rem",
                    fontFamily:"var(--f1)",
                    display:"flex",
                    lineHeight:"1rem"
                }}>The link you are tring to access may be broken or the page my have been removed</p>
            </header>
            <figure style={{
                width:"45%"
            }}>
                <img 
                style={{width:"100%", objectFit:"contain"}}
                src="../images/whiteJewel.png" alt="404"/>
            </figure>
        </div>
    )
}